import React, { useState, useEffect } from "react";
import { message, Input } from "antd";
import http from "../../../../../services/http";
const { TextArea } = Input;

export const SugestoesSugestao = ({ idSugestao }) => {
	const [descricao, setDescricao] = useState("");
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (idSugestao > 0) {
			listarSugestoesSugestao(idSugestao);
		}
	}, [idSugestao]);

	// LISTAR
	const listarSugestoesSugestao = async (id_sugestao) => {
		setLoading(true);
		const api = await http("get", `v1/sugestoes_mensagens/carregar/${id_sugestao}?tipo=1`, []);
		if (api.statusCode === 200) {
			setDescricao(api?.response?.data?.texto);
		} else {
			message.error(api.response.message);
		}
		setLoading(false);
	};

	// ADICIONAR
	const salvarSugestoesSugestao = async (descricao) => {
		setLoading(true);
		const form = {
			id_sugestoes: idSugestao,
			texto: descricao,
			tipo: 1,
		};
		const api = await http("post", `v1/sugestoes_mensagens/adicionar`, form);
		if (api.statusCode === 200) {
			message.success("Alteração atualizada!");
		} else {
			message.error(api.response.message);
		}
		setLoading(false);
	};

	return (
		<TextArea
			disabled={loading}
			rows={10}
			onChange={(e) => setDescricao(e?.target?.value)}
			value={descricao}
			onBlur={() => salvarSugestoesSugestao(descricao)}
			placeholder="Informe a descrição"
		/>
	);
};
